<template>
  <div class="album">
    <v-container grid-list-md text-xs-center class="c-main-shadow swipe">
      <tab-year-month
        v-if="yyyymm != -1"
        ref="ymTab"
        id="album-ym"
        :cid="id"
        :yyyymm="yyyymm"
        :createNewTitle="$T('button.add')"
        :slots="slots"
        useNodate
        @add="openUploadDialog"
        @prepareSlot="prepareSlot"
        @prepareSubSlot="prepareSubSlot"
        @removeSlots="removeSlots"
        @saveHistory="saveHistory"
        @inview="onInview"
      >
        <template v-for="(s, idx) in slots" :slot="s.idx">
          <div v-if="s.destroy"></div>
          <album-month
            v-else
            :ref="`m-${s.ym}`"
            :inview="s.inview"
            :error="s.error"
            :data="s.data"
            :ym="s.ym"
            @activateStarted="onActivateStarted"
            @allActivated="onAllActivated"
          ></album-month>
        </template>
      </tab-year-month>

      <spinner v-else></spinner>
    </v-container>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import UTILS from '../../utils/utils';
import { getList, getViewItem } from '../../api/album';
import tabYearMonth from '../common/TabYearMonth.vue';
import albumMonthComponent from './AlbumMonthComponent.vue';

export default {
  beforeRouteEnter(route, redirect, next) {
    console.log('enter history');
    next(vm => vm.updateHistory());
  },
  beforeRouteUpdate(to, from, next) {
    this.id = Number(to.params.id);
    next();
  },
  components: {
    'tab-year-month': tabYearMonth,
    'album-month': albumMonthComponent,
  },
  mounted: function() {
    var self = this;
    window.addEventListener('popstate', this.onPopstate);
  },
  beforeDestroy: function() {
    window.removeEventListener('popstate', this.onPopstate);
  },
  computed: {
    stateViewer() {
      return this.$store.state.viewer.viewer;
    },
    stateUploadedFiles() {
      return this.$store.state.file.uploadedFiles;
    },
    stateChangeDateFiles() {
      return this.$store.state.viewer.changeDateFiles;
    },
    stateDeletedFiles() {
      return this.$store.state.viewer.deletedFiles;
    },
  },
  watch: {
    stateViewer(newVal, oldVal) {
      if (!newVal) {
        this.saveHistory(this.yyyymm, true);
        this.viewerInitYm = null;
        this.$refs.ymTab.adjustHeightRestart(100);
      }
    },
    stateUploadedFiles(n, o) {
      if (!n.length) return (this.nextUploadIdx = 0);
      for (var i = this.nextUploadIdx; i < n.length; i++) {
        var data = n[i];
        var item = data.item;
        var ym = Number(data.ym);
        this.appendItemToCache(item.community_id, ym, item);
        this.appendItemToCache(0, ym, item);
      }
      this.nextUploadIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
    stateChangeDateFiles(n, o) {
      if (!n.length) return (this.nextChangeDateIdx = 0);
      for (var i = this.nextChangeDateIdx; i < n.length; i++) {
        var data = n[i];
        var item = data.item;
        // use use timezone, no use item timezone.
        // ts is in milliseconds (BE album tstamp), so use $moment(ms) — NOT $moment.unix(seconds),
        // which yielded a far-future ym and made removeItemFromCache/appendItemToCache miss the grid cache.
        var fromYm = data.from == null ? 0 : Number(this.$moment(data.from).format('YYYYMM'));
        var toYm = data.to == null ? 0 : Number(this.$moment(data.to).format('YYYYMM'));
        this.removeItemFromCache(item.community_id, fromYm, item);
        this.appendItemToCache(item.community_id, toYm, item);
        this.removeItemFromCache(0, fromYm, item);
        this.appendItemToCache(0, toYm, item);
      }
      this.nextChangeDateIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
    stateDeletedFiles(n, o) {
      if (!n.length) return (this.nextDeletedIdx = 0);
      for (var i = this.nextDeletedIdx; i < n.length; i++) {
        var item = n[i];
        // ts is in milliseconds — use $moment(ms), not $moment.unix(seconds). The seconds-based ym was a
        // far-future month, so removeItemFromCache never matched and the deleted image stayed in the album
        // grid until a reload re-fetched the list.
        var ym = !item.ts ? 0 : Number(this.$moment(item.ts).format('YYYYMM'));
        this.removeItemFromCache(item.community_id, ym, item);
        this.removeItemFromCache(0, ym, item);
      }
      this.nextDeletedIdx = n.length;
      this.$refs.ymTab.adjustHeightRestart(100);
    },
  },
  data() {
    return {
      id: Number(this.$route.params.id),
      yyyymm: this.initYyyyMm(),
      slots: [],
      cache: {},
      viewerInitYm: null,
      nextUploadIdx: 0,
      nextChangeDateIdx: 0,
      nextDeletedIdx: 0,
      currentYm: Number(this.$moment().format('YYYYMM')),
    };
  },
  methods: {
    isRouteForViewer() {
      return this.$route.name == 'viewer';
    },
    removeItemFromCache(cid, ym, item) {
      var items = this.cache[this.localCacheKey(cid, ym)];
      if (!items) return;
      for (var idx = 0; idx < items.length; idx++) {
        if (item.id == items[idx].id) {
          items.splice(idx, 1);
          this.$commin.clientdb.putObject(this.clientDbKey(cid, ym), items);
          return;
        }
      }
    },
    appendItemToCache(cid, ym, item) {
      var items = this.cache[this.localCacheKey(cid, ym)];
      if (!items) return;
      if ((ym == 0 && item.ts) || (ym != 0 && !item.ts)) {
        console.warn(`invalid values ym=${ym} ts=${item.ts}`);
        items.push(item);
        this.$commin.clientdb.putObject(this.clientDbKey(cid, ym), items);
        return;
      }

      var inserted = false;
      if (items.length == 0) {
        items.push(item);
        inserted = true;
      } else if (ym == 0 ? item.created_at > items[0].created_at : item.ts <= items[0].ts && item.ts >= items[0].ts) {
        items.unshift(item);
        inserted = true;
      } else {
        for (var i = 1, n = items.length; i < n; i++) {
          if (
            ym == 0
              ? item.created_at <= items[i - 1].created_at && item.created_at >= items[i].created_at
              : item.ts <= items[i].ts && item.ts >= items[i].ts
          ) {
            inserted = true;
            items.splice(i, 0, item);
            break;
          }
        }
      }
      if (!inserted) {
        items.push(item);
      }
      this.$commin.clientdb.putObject(this.clientDbKey(cid, ym), items);
    },
    prepareViewer() {
      var ps = this.$route.params;
      var viewerKey = this.clientDbViewerItemKey(ps.fid);
      var self = this;
      this.$commin.clientdb.getObject(viewerKey, function(data) {
        if (data) self.setupViewerPage(data, true);
      });
      getViewItem(ps.fid)
        .then(function(response) {
          self.setupViewerPage(response, false);
          self.$commin.clientdb.putObject(viewerKey, response);
        })
        .catch(function(err) {
          console.error(`failed to get view data for ${ps.fid}`, err);
        });
    },
    setupViewerPage(data, fromCache) {
      if (this.isOpeningDialog && fromCache) return;
      console.log(`set new viewer data ${data}`);
      if (this.id != 0 && data.cid != this.id) {
        this.id = data.cid;
      }
      this.viewerInitYm = Number(data.ym);
      this.yyyymm = Number(data.ym);
      this.$store.commit('OPEN_VIEWER', { item: data.item, items: [data.item] });
    },
    initYyyyMm() {
      if (this.$route.name == 'viewer') return -1;
      return this.calcYyyyMm(this.$route.params.t ? this.$route.params.t : this.loadYm(this.currentYm));
    },
    calcYyyyMm(t) {
      if (!t) return this.currentYm;
      if (t == 'n') return 0;
      t = Number(t);
      return t > CONST.tab_ym.limit.max || t < CONST.tab_ym.limit.min ? this.currentYm : t;
    },
    onPopstate(e) {
      if (!e.state) return;
      var data = null;
      try {
        data = JSON.parse(e.state);
      } catch (ex) {
        console.log('failed to parse history, but ok. this will be change community.');
        return;
      }
      if (data.page != 'album') return;
      this.saveYm(data.ym);
      this.setTitle(data.ym, data.id);
      if (this.id != data.id) {
        this.id = Number(data.id);
        this.$refs.ymTab.refreshData(data.ym);
      } else {
        this.$refs.ymTab.historyBack(data.ym);
      }
      console.log(`history back to ${data.ym}`);
    },
    saveHistory(ym, force) {
      if (!force && this.isRouteForViewer()) return;
      console.log(`save history to ${ym} id=${this.id}`);
      this.saveYm(ym);
      this.setTitle(ym);
      var path = `/album/${this.id}/${ym || 'n'}`;
      if (this.isGuest) path += `/${window.$L}/guest`;
      this.$store.commit('PATH', path);
      history.pushState(JSON.stringify({ page: 'album', id: this.id, ym: ym }), document.title, path);
      this.$ga?.page(path); // GA は prod ホストのみ install（main.js）。非 prod では $ga 不在のため optional chaining で no-op
    },
    updateHistory() {
      if (this.isRouteForViewer()) {
        this.prepareViewer();
        return;
      }
      var ym = this.initYyyyMm();
      if (ym) console.log(`update history to ${ym} id=${this.id} href=${location.href}`);
      this.setTitle(ym);
      history.replaceState(JSON.stringify({ page: 'album', id: this.id, ym: ym }), document.title, location.href);
    },
    setTitle(ym) {
      this.$utils.setDocumentTitleWithFreeWord(`ALBUM ${ym}`, this.id);
    },
    prepareSlot(ym, idx) {
      console.log(`prepare for ${ym} id=${this.id}`);
      this.prepare(ym, idx, true, this.getData(idx, ym, true));
    },
    prepareSubSlot(ym, idx, current) {
      this.prepare(ym, idx, false, this.getData(idx, ym, false));
    },
    prepare(ym, idx, inview, data) {
      this.slots.push({
        idx: idx,
        ym: ym,
        inview: inview,
        error: false,
        destroy: false,
        data: data,
      });
    },
    removeSlots(idxes) {
      var c = 0;
      for (var i = this.slots.length - 1; i >= 0; i--) {
        var idx = idxes.indexOf(this.slots[i].idx);
        if (idx != -1) {
          this.slots[i].destroy = true;
          this.slots[i].data.d = null;
          if (idxes.length == 1) break;
          idxes.splice(idx, 1);
        }
      }
    },
    onInview(idx) {
      var slot = this.getSlot(idx);
      slot.inview = true;
    },
    getData(idx, ym, wide) {
      var id = this.id;
      var key = this.localCacheKey(id, ym);
      var d = this.cache[key];

      // if there is in temp cache, don't access to server.
      if (d) {
        console.log(`use local cache for ${ym}`);
        return { s: 'cache', d: d };
      }

      this.getDataFromCliendDb(idx, id, ym);
      this.getDataFromServer(idx, id, ym, wide);

      return { s: 'preparing', d: d };
    },
    getDataFromCliendDb(idx, id, ym) {
      var self = this;
      this.$commin.clientdb.getObject(this.clientDbKey(id, ym), function(data) {
        if (data) {
          console.log(`got data from client db id${id} ym${ym}`);
          self.setData(idx, id, ym, data, false, true);
        }
      });
    },
    getDataFromServer(idx, id, ym, wide) {
      var self = this;
      getList(id, ym ? ym : 'n', wide)
        .then(function(response) {
          for (var key in response) {
            var resultYm = Number(key.substring(1));
            self.setData(idx, id, resultYm, response[key], true, resultYm == ym);
          }
        })
        .catch(function(error) {
          console.error('failed to get album data', error);
          self.setError(idx, ym);
        });
    },
    setData(idx, id, ym, data, serverData, setSlot) {
      const adjustedData = this.adjustData(data, ym);
      if (serverData) {
        if (setSlot) {
          this.getSlot(idx).data = { s: 'done', d: adjustedData };
        }
        this.cache[this.localCacheKey(id, ym)] = adjustedData;
        this.$commin.clientdb.putObject(this.clientDbKey(id, ym), data);

        if (this.viewerInitYm == ym) {
          // lazy update.
          var self = this;
          setTimeout(function() {
            if (self.viewerInitYm == ym) {
              self.$store.commit('UPDATE_VIEWER', adjustedData.concat());
              self.viewerInitYm = null;
            }
          }, 500);
        }
      } else if (setSlot) {
        var slot = this.getSlot(idx);
        if (slot.data.s != 'done') {
          slot.data = { s: 'clientdb', d: adjustedData };
        }
      }
    },
    adjustData(files, ym) {
      if (ym == 0) return files;
      const d1 = this.ymToDay1(ym);
      const start = d1.valueOf();
      const d2 = d1.add(1, 'month');
      const end = d2.valueOf();
      return files.filter(v => start <= v.ts && v.ts < end);
    },
    setError(idx, ym) {
      var slot = this.getSlot(idx);
      slot.error = true;
    },
    getSlot(idx) {
      for (var i = this.slots.length - 1; i >= 0; i--) {
        if (this.slots[i].idx == idx) {
          return this.slots[i];
        }
      }
    },
    openUploadDialog() {
      this.$store.commit('OPEN_UPLOAD', {});
    },
    localCacheKey(id, ym) {
      return `d-${id}-${ym}`;
    },
    clientDbKey(id, ym) {
      return `album-${id}-${ym}`;
    },
    clientDbViewerItemKey(id) {
      return `viewer-${id}`;
    },
    onActivateStarted(ym) {
      if (this.$store.state.tools.yyyymm != ym) return;
      this.stopActivation(`m-${this.$utils.toYyyyMm(ym - 1)}`);
      this.stopActivation(`m-${this.$utils.toYyyyMm(ym + 1)}`);
    },
    stopActivation(refKey) {
      var tgts = this.$refs[refKey];
      if (!tgts || tgts.length == 0) return console.log(`there is no key for ${refKey}`);
      for (var tgt of tgts) {
        tgt.startActivation();
      }
    },
    onAllActivated(ym) {
      if (this.$store.state.tools.yyyymm != ym) return;
      var self = this;
      setTimeout(function() {
        if (self.$store.state.tools.yyyymm != ym) return console.log(`${self.$store.state.tools.yyyymm} is not ${ym}`);

        self.startActivation(`m-${self.$utils.toYyyyMm(ym - 1)}`);
        self.startActivation(`m-${self.$utils.toYyyyMm(ym + 1)}`);
      }, 500);
    },
    startActivation(refKey) {
      var tgts = this.$refs[refKey];
      if (!tgts || tgts.length == 0) return console.log(`there is no key for ${refKey}`);
      for (var tgt of tgts) {
        tgt.startActivation();
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 10px;
  min-height: calc(100vh - 200px);
}
.le-tbs .container {
  min-height: calc(100vh - 156px);
}
</style>
